module.exports = __webpack_public_path__ + "img/zoomed-PS-withwords.79a40c88.png";